export const GET_PAGE_BY_ID_SUCCESS = "GET_PAGE_BY_ID_SUCCESS"
export const GET_WIDGETS = "GET_WIDGETS"
export const GET_WIDGETS_SUCCESS = "GET_WIDGETS_SUCCESS"
export const UPDATE_PAGE_SUCCESS = "UPDATE_PAGE_SUCCESS"

export const RESET_PAGE_PROPS = "RESET_PAGE_PROPS"
//DICTIONARY
export const SET_DICTIONARY_WIDGET_TEMP_NEW_ID = "SET_DICTIONARY_WIDGET_TEMP_NEW_ID"
export const CLEAR_DICTIONARY = "CLEAR_DICTIONARY"

// DEPRECATED: Filter state moved to FilterStore (CustomEvents). See app/grc/shared/stores/filterStore.ts
export const SET_FILTER_VALUE = "SET_FILTER_VALUE"
export const CLEAR_VALUE_FILTER_SELECTED = "CLEAR_VALUE_FILTER_SELECTED"
export const REMOVE_SELECTED_VALUE = "REMOVE_SELECTED_VALUE"

//COMPARISON VALUE SELECTION
export const SELECT_COMPARISON_VALUE = "SELECT_COMPARISON_VALUE"
export const REMOVE_COMPARISON_VALUE = "REMOVE_COMPARISON_VALUE"
export const CLEAR_COMPARISON_VALUES = "CLEAR_COMPARISON_VALUES"

//PAGE THUMBNAIL
export const SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL = "SCREENSHOT_AND_SAVE_PAGE_THUMBNAIL"

//WIDGET DATA
export const GET_WIDGET_DATA = "GET_WIDGET_DATA"
export const GET_WIDGET_DATA_SUCCESS = "GET_WIDGET_DATA_SUCCESS"
export const GET_FIELD_INFOS = "GET_FIELD_INFOS"
export const GET_FIELD_INFOS_SUCCESS = "GET_FIELD_INFOS_SUCCESS"
export const CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT =
  "CLONE_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT"
export const CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED =
  "CLONE_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED"
export const CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT =
  "CLONE_FILTER_DATA_FROM_WIDGET_BEING_EDITED_AND_CLEAN_IT"
export const CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED =
  "CLONE_FILTER_DATA_FROM_WIDGET_TO_WIDGET_BEING_EDITED"

// UPLOADS
export const UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET = "UPLOAD_WIDGET_IMAGE_PAGE_STATUS_RESET"
export const UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING = "UPLOAD_WIDGET_IMAGE_PAGE_STATUS_PENDING"
export const UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS = "UPLOAD_WIDGET_IMAGE_PAGE_STATUS_SUCCESS"

// REQUEST STATUS
export const SET_WIDGET_REQUEST_STATUS = "SET_WIDGET_REQUEST_STATUS"

export const SET_LAST_WIDGET_SAVED = "SET_LAST_WIDGET_SAVED"

export const CHANGE_SAVING_PAGE_STATUS = "CHANGE_SAVING_PAGE_STATUS"

// DRILL DOWN
export const SET_DRILLDOWN_ENABLED = "SET_DRILLDOWN_ENABLED"

// AUTO-REFRESH
// Counter incremented when the cube has just been recalculated: each widget watches it and
// re-queries the API. Avoids window.location.reload(), which would lose filters and scroll position.
export const BUMP_DATA_REFRESH_TOKEN = "BUMP_DATA_REFRESH_TOKEN"
